import { z } from "zod";

/**
 * `GET /api/v1/banks`'s item, **as the OpenAPI document declares it** (`PRET-BANKS`, #556: `BANK_ITEM_SCHEMA` in
 * `openapi.document.ts`) , the shape a client PARSES at its boundary instead of casting.
 *
 * The generated `api-client` is path-only: it types a request's path and verb, not the answer's body, so the console read
 * `{ banks?: BankView[] }` off an `as` and `active` , `lending.banks.active`, the panel membership , rode a hand-written
 * type. This mirrors the document key for key; `openapi.banks-contract.spec.ts` (in the api) holds the two together, so a key
 * added to one and not the other fails there. `volumes`, `prefilters` and `criteria` are declared as an object, an array and
 * an object and nothing more, exactly as the document does; a client that reads inside them narrows them itself.
 *
 * Not strict: the door answers more than the document declares (the convention and the criteria's fields on the sheet), and an
 * extra key is a surplus the client ignores, never a mismatch. A MISSING or mistyped declared key is.
 */
export const BANK_CONFIG_STATES = ["complete", "criteresAParametrer"] as const;

export const bankListItemSchema = z.looseObject({
  id: z.string(),
  organisationId: z.string(),
  name: z.string(),
  configState: z.enum(BANK_CONFIG_STATES),
  /** Membership of the panel: the filter considers only the banks where this is true (`lending.banks.active`). */
  active: z.boolean(),
  volumes: z.looseObject({}),
  prefilters: z.array(z.unknown()),
  criteria: z.looseObject({}),
});

export const bankListAnswerSchema = z.looseObject({
  banks: z.array(bankListItemSchema),
});

export type BankListItem = z.infer<typeof bankListItemSchema>;
export type BankListAnswer = z.infer<typeof bankListAnswerSchema>;
